import { action } from 'satcheljs';

/**
 * Called when we select discard, it resets the guided capture options in store
 */
export let discardGuidedCaptureOptions = action('discardGuidedCaptureOptions');

/**
 * Saves the autoCollectionEnabled option in store
 */
export let setAutoCollectionEnabled = action(
    'setAutoCollectionEnabled',
    (autoCollectionEnabled: boolean) => ({
        autoCollectionEnabled: autoCollectionEnabled,
    })
);
